import { useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { RestartIcon } from '@app-velocity/icons';

import {
  useAiChatContext,
  useScenarioDetailsContext,
} from '@app-velocity/modules/scenarios';

import { MessageBus } from '@app-velocity/message-bus';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { ActionButton } from '../ActionButton';

const messageBus = new MessageBus('prototypes');

export const ActionTryAgain = () => {
  const { t } = useI18n();

  const currentTeam = useCurrentTeamPermissions();
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { scenario } = useScenarioDetailsContext();
  const { persona } = useAiChatContext();

  const handleRetry = () => {
    if (!workspaceId || !teamId || !scenario || !currentTeam) return;

    if (!currentTeam.canRunSimulations(1)) {
      return;
    }

    messageBus.publish('modal:run-again:open', {
      workspaceId,
      teamId,
      scenarioId: scenario.id!,
      shareToken: scenario.shareToken!,
      amount: 1,
      type: 'SINGLE',
      persona,
    });
  };

  return (
    <ActionButton onClick={handleRetry}>
      {t('prototypes:try_again')} <RestartIcon />
    </ActionButton>
  );
};
